export default "__VITE_ASSET__DEV9TgmR__"